import { render, staticRenderFns } from "./natural.vue?vue&type=template&id=5212ce60&scoped=true&"
import script from "./natural.vue?vue&type=script&lang=js&"
export * from "./natural.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5212ce60",
  null
  
)

export default component.exports